var _rect, _rect2, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 353,
    viewBox: "0 0 266 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 353,
    rx: 20,
    fill: "#FFE184"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 146.5,
    width: 61,
    height: 61,
    rx: 30.5,
    stroke: "white",
    strokeWidth: 15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 165.557,
    y1: 68.7656,
    x2: 103.233,
    y2: 128.025,
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 104.766,
    y1: 67.2327,
    x2: 164.025,
    y2: 129.557,
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 165.557,
    y1: 228.766,
    x2: 103.233,
    y2: 288.025,
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 104.766,
    y1: 227.233,
    x2: 164.025,
    y2: 289.557,
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBack);
export default __webpack_public_path__ + "static/media/card-back.ebdb1094ec825cd108d9043b43506587.svg";
export { ForwardRef as ReactComponent };